import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./index.css";
import {
  Pagination,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  DialogTitle,
  useMediaQuery,
  Button,
  DialogContentText
} from "@mui/material";
import { MdAdd } from "react-icons/md";
import axios from "axios";
import { useTheme } from "@mui/material/styles";
import { updateAlert, updateProjects, updateUnapprovedProjects } from "../../redux/actions";
import NewCard from "../../components/NewCard";
import ContextMenu from "../../../../common/ContextMenu";
import AddProject from "./components/AddProject";
import EditProject from "./components/EditProject";
import SearchBar from "../../components/SelectField/SearchBar";

function Projects(props) {
  const [createOpen, setCreateOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false)
  const theme = useTheme();
  const [projects, setProjects] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const [unapprovedProjects, setUnapprovedProjects] = useState([])
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  // ---------- delete project ----------
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)
  const [deleteName, setDeleteName] = useState("")

  const [reload, setReload] = useState(false);
  const [selectedProject, setSelectedProject] = useState({})

  useEffect(() => {
    if (props.projects === null || reload) {
      axios({
        method: "get",
        url: `/api/m2d/projects`,
      }).then((res) => {
        setProjects(res.data);
        setAllProjects(res.data);
        props.handleProjects(res.data)
        setReload(false)
      });
    } else {
      setProjects(props.projects)
    }

  }, [reload, props]);

  useEffect(() => {
    if (props.unapprovedProjects === null || reload) {
      axios({
        method: "post",
        url: `/api/m2d/projects/getUnapprovedProjects`,
        data: {
          uid: props.user.id
        }
      }).then((res) => {
        if (res.data.length > 0) {
          setUnapprovedProjects(res.data[0].m2dProjects);
          props.handleUnapprovedProjects(res.data[0].m2dProjects);
        } else {
          props.handleUnapprovedProjects([]);
        }
        setReload(false)
      });
    } else {
      setUnapprovedProjects(props.unapprovedProjects)
    }

  }, [reload, props]);

  const navigate = useNavigate();

  const handleMore = (e) => {
    if (props.user.id) {
      navigate(`/m2d/projects/${e.currentTarget.id}`);
    } else {
      props.handleAlert("error", "Please login first!", 3000);
    }
  };

  const handleAddProject = () => {
    setCreateOpen(true);
  };

  const handleOpen = (id) => () => {
    navigate(`/m2d/projects/${id}`)
  }

  const handleEdit = (id) => () => {
    let selectedProject = projects.find(proj => proj.id === id)
    if (!selectedProject) {
      selectedProject = unapprovedProjects.find(proj => proj.id === id)
    }
    if (selectedProject.users.find(user => user.id === props.user.id) || props.role === "Admin") {
      setSelectedProject(selectedProject)
      setEditOpen(true)
    }

  }

  const handleRemove = (id) => () => {
    setDeleteConfirmOpen(true)
    const currProject = projects.find(proj => proj.id === id)
    if (currProject) {
      setSelectedProject(currProject)
    } else {
      setSelectedProject(unapprovedProjects.find(proj => proj.id === id))
    }
  }

  const getMenuItems = (id) => {
    let selectedProject = projects.find(proj => proj.id === id)
    if (!selectedProject) {
      selectedProject = unapprovedProjects.find(proj => proj.id === id)
    }

    const menuItems = [
      { label: 'Open', action: handleOpen(id) },
    ];

    if (selectedProject.users.find(user => user.id === props.user.id) || props.role === "Admin") {
      menuItems.push(
        { label: 'Edit', action: handleEdit(id) },
        { label: 'Remove', action: handleRemove(id) },
      )
    }

    return menuItems
  }

  const handleDeleteClose = () => {
    setDeleteConfirmOpen(false)
  }

  const handleDelete = () => {
    if (deleteName !== selectedProject.name) {
      props.handleAlert("error", "Names don't match!", 3000)
    } else {
      axios({
        method: "post",
        url: `/api/m2d/projects/removeProject`,
        data: {
          pid: selectedProject.id,
          uid: props.user.id
        }
      }).then(() => {
        props.handleAlert("success", "Successfully Removed!")
        setDeleteConfirmOpen(false)
        setReload(!reload)
      }).catch((err) => {
        props.handleAlert("error", err.response.data.message, 3000)
        console.log(err)
      })
    }
  }

  const handleKeyDown = (e, content) => {
    // when press enter
    if (e.keyCode === 13) {
      e.preventDefault();
      if (content.length === 0) {
        // if empty search
        setProjects(allProjects);
      } else {
        const results = allProjects.filter(
          project => project.name.toLowerCase().indexOf(content.toLowerCase()) !== -1
            ||
            project.title.toLowerCase().indexOf(content.toLowerCase()) !== -1
        );
        setProjects(results);
      }
    }
  }

  return (
    <>
      <div className="tool-bar">
        <div className="searchbar">
          <SearchBar
            placeholder="Search projects"
            onKeyDown={handleKeyDown}
          />
        </div>
        {["Admin", "Internal"].includes(props.role) ? (
          <div className="add-project" onClick={handleAddProject}>
            <div className="add-icon">
              <MdAdd style={{
                fontSize: '20px',
                marginTop: '5px',
                marginRight: '8px'
              }} />
            </div>
            <span>Create project</span>
          </div>) : null}
      </div>
      <div className="page-content">
        <div className="proj-content">
          {unapprovedProjects.map((project) => {
            return (
              <ContextMenu menuItems={getMenuItems(project.id)} key={project.id}>
                <NewCard project={project} approved={false} handleMore={handleMore} />
              </ContextMenu>
            )
          })}
          {projects.map((project) => {
            return (
              <ContextMenu menuItems={getMenuItems(project.id)} key={project.id}>
                <NewCard project={project} key={project.id} handleMore={handleMore} />
              </ContextMenu>
            );
          })}

          <Pagination count={10} shape="rounded" hidden />
        </div>

        {/* ------ add project component ------ */}

        <AddProject
          fullScreen={fullScreen}
          setReload={setReload}
          createOpen={createOpen}
          setCreateOpen={setCreateOpen}
        />

        {/* ---------- edit project component ---------- */}

        <EditProject
          fullScreen={fullScreen}
          setReload={setReload}
          editOpen={editOpen}
          setEditOpen={setEditOpen}
          selectedProject={selectedProject}
        />

        {/* ---------- delete project ---------- */}

        <Dialog
          open={deleteConfirmOpen}
          onClose={handleDeleteClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {`Are you sure you want to remove ${selectedProject.name}?`}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Removing this project will only remove you out of the project owners. This project
              will be removed when all owners have removed this project. This can <b>NOT</b> be undo.
            </DialogContentText>
            <DialogContentText>
              If you really want to remove yourself from this project, please enter the exact same
              project name below and click confirm.
            </DialogContentText>
            <TextField
              required
              label="Project Name"
              fullWidth
              margin="normal"
              placeholder={selectedProject.name}
              value={deleteName}
              onInput={(e) => setDeleteName(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" color="error" onClick={handleDeleteClose}>Cancel</Button>
            <Button variant="contained" onClick={handleDelete}>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    projects: state.m2d.projects,
    unapprovedProjects: state.m2d.unapprovedProjects,
    role: state.m2d.role
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },

    handleProjects(projects) {
      updateProjects(projects)(dispatch);
    },

    handleUnapprovedProjects(projects) {
      updateUnapprovedProjects(projects)(dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Projects);
